import {
  AuthAccountOrganizationBusinessTypeChoices,
  Typography,
  useFetchFile,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { Card, Image, Spinner } from "@heroui/react";
import { Status } from "@modules/company/constants/statusConfig";
import StatusBadge from "../StatusBadge";

interface ICompanyGeneralInfoProps {
  detail: {
    name?: string;
    logo?: string;
    status?: string;
    businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
    employeeCooperationStatusCounts?: {
      suspended?: number | null;
      resigned?: number | null;
      fired?: number | null;
      finished?: number | null;
      awaiting?: number | null;
      active?: number | null;
    };
  };
  isLoading?: boolean;
}
const CompanyGeneralInfo = ({ detail, isLoading }: ICompanyGeneralInfoProps) => {
  const { data: file, loading: logoLoading } = useFetchFile({ urlPath: detail.logo, userType: UserTypeEnum.ADMIN });
  const staticData = [
    {
      title: "Suspended",
      value: detail.employeeCooperationStatusCounts?.suspended,
    },
    {
      title: "Resigned",
      value: detail.employeeCooperationStatusCounts?.resigned,
    },
    {
      title: "Fired",
      value: detail.employeeCooperationStatusCounts?.fired,
    },
    {
      title: "Ended",
      value: detail.employeeCooperationStatusCounts?.finished,
    },
    {
      title: "Awaiting",
      value: detail.employeeCooperationStatusCounts?.awaiting,
    },
    {
      title: "Active",
      value: detail.employeeCooperationStatusCounts?.active,
    },
  ];

  return (
    <Card className="flex-row items-center justify-between py-5 px-4 min-h-fit shadow-sm border-1 border-zinc-100 rounded-lg ">
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="flex items-center gap-3">
            {file ? (
              <Image
                src={file}
                alt="Company Logo"
                className="w-16 h-16 rounded-xl"
                isLoading={logoLoading}
                classNames={{
                  img: logoLoading ? "opacity-0" : "opacity-1",
                }}
              />
            ) : (
              <div className="w-16 h-16 bg-gray-200 rounded-xl" />
            )}
            <div>
              <div className="flex items-center gap-1">
                <Typography variant="h4">{detail.name}</Typography>
                <StatusBadge status={detail.status as Status} />
              </div>
              <Typography variant="h5" className="!font-medium text-zinc-500 capitalize">
                {detail.businessType?.toLowerCase()}
              </Typography>
            </div>
          </div>
          <div className="flex gap-9 me-5">
            {staticData.map((item) => (
              <div key={item.title} className="flex flex-col items-center gap-1">
                <Typography className="text-xs text-zinc-700">{item.title} :</Typography>
                <Typography variant="h5">{item.value}</Typography>
              </div>
            ))}
          </div>
        </>
      )}
    </Card>
  );
};

export default CompanyGeneralInfo;
